import { render, staticRenderFns } from "./SettingsEmailTemplateConfiguration.vue?vue&type=template&id=39aca4c0"
import script from "./SettingsEmailTemplateConfiguration.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateConfiguration.vue?vue&type=style&index=0&id=39aca4c0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports